import { render, staticRenderFns } from "./Fire.vue?vue&type=template&id=29bca5c9"
import script from "./Fire.vue?vue&type=script&lang=ts"
export * from "./Fire.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports